import { render } from "./DemandByPrice.vue?vue&type=template&id=0a1c4caf&scoped=true"
import script from "./DemandByPrice.vue?vue&type=script&lang=js"
export * from "./DemandByPrice.vue?vue&type=script&lang=js"

import "./DemandByPrice.vue?vue&type=style&index=0&id=0a1c4caf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1c4caf"]])

export default __exports__